export default __webpack_public_path__ + "assets/c94aa7dce81cbed612cc9adc367addb5.png";